// ==============================|| OVERRIDES - DRAWER ||============================== //

export default function Drawer() {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          /*
           * Mixing overflow-x: visible with overflow-y: hidden forces the browser to treat
           * overflow-x as auto, which clips controls that sit half outside the paper (drawer toggle).
           * Keep paper fully visible; constrain scrolling inside DrawerContent only.
           */
          overflow: 'visible',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            width: 0,
            height: 0,
            display: 'none'
          }
        }
      }
    }
  };
}
